/**
 * The visitor (IMPLEMENTATION.md R10 step 1): one id per browser, set the first time anyone lands,
 * kept in localStorage, sent with every event batch and carried onto the company at sign-up so
 * the anonymous visit (pricing, sign-up form) joins the company's story. It is a random id, never
 * a fingerprint, and it is gone when the browser's storage is.
 */
const KEY = 'paige.visitor';

let inMemory: string | null = null;

export function visitorId(): string {
  if (inMemory) return inMemory;
  try {
    const kept = localStorage.getItem(KEY);
    if (kept) return (inMemory = kept);
    const fresh = crypto.randomUUID();
    localStorage.setItem(KEY, fresh);
    return (inMemory = fresh);
  } catch {
    return (inMemory = crypto.randomUUID());
  }
}

export function resetVisitorForTests(): void {
  inMemory = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no storage */
  }
}
